import { ILocaleStrings } from './index'

export default {
    'common.logout': 'התנתק',
    'common.mv': 'מילי-וולט',
    'common.v': 'V',
    'common.celsius': '°C',
    'common.bar': 'בר',
    'common.rps': 'סיבובים לשניה',
    'common.saved': 'נשמר',
    'common.success': '{0} בהצלחה',
    'common.on_cooldown': '{0} נמצא בהשהייה',
    'common.activate': 'הפעל {0}',
    'common.finished': 'הסתיים',
    'common.save': 'שמירה',
    'common.unsaved_changes': 'ישנם שינויים לא שמורים',
    'common.edit': 'עריכה',
    'common.delete': 'מחיקה',
    'common.deleted': 'נמחק',
    'common.old_software_message': 'גרסא מיושנת, ניתן לעדכן לגרסא {0}',
    'common.activated': 'הופעל לפני {0}',
    'common.deactivated': 'נכבה לפני {0}',
    'common.status': 'סטטוס',
    'common.previous': 'הקודם',
    'common.next': 'הבא',
    'common.first_page': 'עמוד ראשון',
    'common.last_page': 'עמוד אחרון',
    'common.thermostat': 'תרמוסטט',
    'common.active_time': 'זמן פעילות',
    'common.inactive_time': 'זמן השהייה',
    'common.disconnected': 'מנותק',
    'common.cancel': 'בטל',
    'common.ambient_temp': 'טמפרטורת סביבה',
    'common.included': 'כלול',
    'common.excluded': 'לא כלול',
    'common.scan': 'סריקה',
    'common.loading': 'טוען',
    'common.counter': 'מונה',
    'common.show_password': 'הצג סיסמה',
    'common.hide_password': 'הסתר סיסמה',

    'pagelabels.login': 'התחברות',
    'pagelabels.dashboard_internal': 'לוח מכשירים פנימי',
    'pagelabels.dashboard_external': 'לוח מכשירים חיצוני',
    'pagelabels.client': 'לקוח',
    'pagelabels.datacenter': 'מרכז נתונים',
    'pagelabels.machine': 'מכשיר',
    'pagelabels.software-manager': 'קבצי OTA',
    'pagelabels.mobile_apps': 'אפליקציות מובייל',
    'pagelabels.usb_flash_artifacts': 'קבצי צריבה ל-USB',
    'pagelabels.usb_flasher_web': 'צריבת USB (דפדפן)',
    'pagelabels.usb_flash_erase_web': 'מחיקת פלאש USB (דפדפן)',
    'pagelabels.usb_serial_monitor_web': 'מוניטור סריאלי USB (דפדפן)',
    'pagelabels.quicksupport': 'תמיכה מהירה',
    'pagelabels.admin': 'ניהול',
    'pagelabels.software-version': 'גרסאת תוכנה',
    'pagelabels.new-software-version': 'גרסאת תוכנה חדשה',
    'pagelabels.multiclient': 'צפייה במספר מכשירים',
    'pagesections.dashboards': 'לוחות בקרה',
    'pagesections.artifacts': 'חבילות הפצה',
    'pagesections.administration': 'ניהול',
    'pagesections.user': 'משתמש',

    'time.days': 'ימים',
    'time.hours': 'שעות',
    'time.minutes': 'דקות',
    'time.seconds': 'שניות',
    'time.d': `י'`,
    'time.h': `שע'`,
    'time.m': `ד'`,
    'time.s': `שנ'`,
    'time.less_than_a_second': 'פחות משניה',
    'time.half_second': 'חצי שניה',

    'login.signin_message': 'התחבר למשתמש שברשותך',
    'login.username': 'שם משתמש',
    'login.password': 'סיסמא',
    'login.remember_me': 'זכור אותי',
    'login.button': 'התחבר',
    'login.error.invalid_username': 'שם משתמש לא תקין',
    'login.error.invalid_password': 'סיסמה לא תקינה',
    'login.error.wrong_credentials': 'שם משתמש/מספר משתמש או סיסמה שגויים',
    'login.error.user_disabled': 'המשתמש מושבת',
    'login.error.locked': 'יותר מדי ניסיונות התחברות כושלים. נסה שוב בעוד כמה רגעים.',
    'login.error.locked_seconds': 'יותר מדי ניסיונות התחברות כושלים. נסה שוב בעוד {0} שניות.',
    'login.error.rate_limited': 'הגעת למגבלת בקשות. נסה שוב בעוד כמה רגעים.',
    'login.error.rate_limited_seconds': 'הגעת למגבלת הבקשות. נסה שוב בעוד {0} שניות.',
    'login.error.access_denied': 'הגישה נדחתה',
    'login.error.unexpected': 'ההתחברות נכשלה',

    'dashboard.connected': 'התחבר',
    'dashboard.client_id': 'מזהה לקוח',
    'dashboard.mac': 'כתובת MAC',
    'dashboard.ip': 'כתובת IP',
    'dashboard.model': 'דגם',
    'dashboard.device_name': 'שם התקן',
    'dashboard.phone_model': 'דגם מכשיר',
    'dashboard.system_name': 'שם מערכת',
    'dashboard.system_version': 'גרסאת מערכת',
    'dashboard.no_clients': 'אין לקוחות מחוברים',
    'dashboard.confirm_client_click': 'בחר פעולה',
    'dashboard.enter_client': 'כניסה ללקוח',
    'dashboard.multiple_clients': 'צפה במספר לקוחות',
    'dashboard.selected_clients': 'לקוחות שנבחרו',
    'dashboard.view_clients': 'צפה בלקוחות',
    'push.title': 'התראות פוש',
    'push.not_supported': 'התראות פוש אינן נתמכות בדפדפן זה.',
    'push.subscribe': 'הרשמה',
    'push.unsubscribe': 'ביטול הרשמה',
    'push.test': 'בדיקת פוש',
    'push.subscribed': 'הרשמה להתראות הופעלה',
    'push.unsubscribed': 'הרשמה להתראות בוטלה',
    'push.subscribe_failed': 'ההרשמה להתראות נכשלה',
    'push.unsubscribe_failed': 'ביטול ההרשמה להתראות נכשל',
    'push.test_sent': 'התראת בדיקה נשלחה',
    'push.test_failed': 'שליחת התראת בדיקה נכשלה',
    'push.subscribed_status': 'אתה רשום לקבלת התראות.',
    'push.unsubscribed_status': 'אינך רשום כרגע להתראות.',
    'push.create_rule': 'יצירת כלל התראה',
    'push.metric': 'מדד',
    'push.threshold_minutes': 'סף (דקות)',
    'push.cooldown_minutes': 'קול-דאון (דקות)',
    'push.custom_label': 'תווית מותאמת (אופציונלי)',
    'push.add_rule': 'הוסף כלל',
    'push.no_rules': 'לא הוגדרו כללים למכונה זו.',
    'push.rule_created': 'כלל התראה נוצר',
    'push.rule_create_failed': 'יצירת כלל התראה נכשלה',
    'push.invalid_threshold': 'סף וקול-דאון חייבים להיות חיוביים',
    'push.disable_rule': 'השבת',
    'push.enable_rule': 'הפעל',
    'push.delete_confirm': 'למחוק את כלל ההתראה הזה?',
    'push.rule_line': '{0} מעל {1} דקות (קול-דאון {2} דקות)',
    'push.metric.cooling_unit_active_time': 'זמן פעילות יחידת קירור',
    'push.metric.cooling_unit_inactive_time': 'זמן השהיית יחידת קירור',
    'push.metric.pump_active_time': 'זמן פעילות משאבה',
    'push.metric.pump_inactive_time': 'זמן השהיית משאבה',
    'push.metric.boiler_active_time': 'זמן פעילות בוילר',
    'push.metric.boiler_inactive_time': 'זמן השהיית בוילר',
    'push.metric.fan_active_time': 'זמן פעילות מאוורר',
    'push.metric.fan_inactive_time': 'זמן השהיית מאוורר',
    'push.metric.circulation_pump_active_time': 'זמן פעילות משאבת סחרור',
    'push.metric.circulation_pump_inactive_time': 'זמן השהיית משאבת סחרור',

    'admin.server_controls': 'בקרות שרת',
    'admin.restart_hint': 'השתמש בפעולה זו כדי להפעיל מחדש את תהליך שרת ה-Control Center.',
    'admin.restart_server': 'הפעל מחדש שרת',
    'admin.restarting': 'מפעיל מחדש...',
    'admin.restart_confirm': 'להפעיל מחדש את השרת עכשיו?',
    'admin.restart_sent': 'פקודת אתחול נשלחה. ממתין שהשרת יחזור לאוויר.',
    'admin.restart_failed': 'נכשל בהפעלת השרת מחדש',
    'admin.clear_security_counters': 'אפס מוני אבטחה',
    'admin.clearing_security_counters': 'מאפס מונים...',
    'admin.clear_security_counters_confirm': 'לאפס עכשיו את מוני האבטחה (נעילות התחברות ומגבלות קצב)?',
    'admin.clear_security_counters_done': 'מוני אבטחה אופסו (התחברות: {0}, קצב: {1})',
    'admin.clear_security_counters_failed': 'איפוס מוני האבטחה נכשל',
    'admin.license_center': 'מרכז רישיונות',
    'admin.license_center_hint': 'ניהול רישיונות לכל מכשירי LTSP101 המחוברים במקום אחד.',
    'admin.license_load_error': 'טעינת נתוני רישוי נכשלה',
    'admin.license_no_ltsp': 'לא נמצאו מכשירי LTSP101 מחוברים.',
    'admin.license_open_device': 'פתח לשונית רישוי של המכשיר',
    'admin.license_manager': 'ניהול מפתחות רישוי',
    'admin.license_manager_hint': 'יצירה, עריכה, שלילה ומחיקה של מפתחות רישוי LTSP101.',
    'admin.license_create': 'צור רישיון',
    'admin.license_created': 'הרישיון נוצר',
    'admin.license_create_error': 'יצירת הרישיון נכשלה',
    'admin.license_updated': 'הרישיון עודכן',
    'admin.license_update_error': 'עדכון הרישיון נכשל',
    'admin.license_deleted': 'הרישיון נמחק',
    'admin.license_delete_error': 'מחיקת הרישיון נכשלה',
    'admin.license_delete_confirm': 'למחוק את מפתח הרישיון הזה?',
    'admin.license_key_optional': 'מפתח רישיון (אופציונלי, ייווצר אוטומטית אם ריק)',
    'admin.license_key_label': 'מפתח רישיון',
    'admin.license_plan_label': 'תוכנית',
    'admin.license_plan_monthly': 'חודשי',
    'admin.license_plan_yearly': 'שנתי',
    'admin.license_plan_custom': 'מותאם אישית',
    'admin.license_duration_label': 'משך (ימים)',
    'admin.license_notes_label': 'הערות',
    'admin.license_duration_help': 'המשך הוא בימים. הערך 30 אומר 30 ימים מרגע ההפעלה.',
    'admin.license_duration_days': 'משך ימים',
    'admin.license_notes': 'הערות',
    'admin.license_device_id': 'מזהה מכשיר משויך (אופציונלי)',
    'admin.license_revoke': 'שלול',
    'admin.license_unrevoke': 'בטל שלילה',
    'admin.license_no_records': 'לא נמצאו רישיונות',
    'admin.usb_flasher_code_label': 'קוד גישה לצריבת USB ציבורית',
    'admin.usb_flasher_code_refresh_in': 'מתחלף בעוד',
    'admin.usb_flasher_code_error': 'טעינת קוד הגישה לצריבה נכשלה',

    'client.disconnect_message': 'לקוח {0} התנתק',
    'client.system_info': 'מידע על המערכת',
    'client.logs': 'יומנים',
    'client.settings': 'הגדרות',
    'client.wifi_config': 'ווי-פי',
    'client.datetime': 'שינוי תאריך ושעה',
    'client.customer_data': 'נתוני לקוח',
    'client.channels': 'ערוצים',
    'client.system_actions': 'פעולות מערכת',
    'client.monitoring': 'ניטור',
    'client.ota': 'עדכון תוכנה',
    'client.flash_device': 'צריבה ראשונית',

    'monitoring.title': 'ניטור',
    'monitoring.description': 'הפעל ניטור בצד השרת כדי שהחוקים להתראות פוש ייבדקו באופן רציף.',
    'monitoring.enabled': 'הניטור פעיל',
    'monitoring.disabled': 'הניטור כבוי',
    'monitoring.enable': 'הפעל ניטור',
    'monitoring.disable': 'השבת ניטור',
    'monitoring.required_for_push': 'כדי שחוקי הפוש יעבדו יש להפעיל ניטור.',
    'monitoring.live_title': 'ניטור חי',
    'monitoring.updated_at': 'עודכן',

    'channels.title': 'ניהול ערוצים',
    'channels.loading': 'טוען ערוצים...',
    'channels.all_control': 'שליטה בכל הערוצים',
    'channels.channel': 'ערוץ',
    'channels.active': 'פעיל',
    'channels.inactive': 'לא פעיל',
    'channels.mode': 'מצב',
    'channels.mode_solenoid': 'סולנואיד',
    'channels.mode_relay': 'ממסר',
    'channels.pwm': 'PWM',
    'channels.syrup_id': 'מזהה סירופ',
    'channels.syrup_none': 'אין',
    'channels.status': 'סטטוס',
    'channels.calibrating': 'מבצע כיול...',
    'channels.ready': 'מוכן',
    'channels.calibration': 'כיול',
    'channels.not_calibrated': 'לא מכויל',
    'channels.turn_on': 'הדלק',
    'channels.turn_off': 'כבה',
    'channels.edit_channel': 'ערוך ערוץ',
    'channels.save': 'שמור',
    'channels.cancel': 'ביטול',
    'channels.all_control_title': 'שליטה בכל הערוצים',
    'channels.all_control_desc': 'בחר פעולה להחיל על כל הערוצים הפעילים:',
    'channels.all_on': 'הדלק הכל',
    'channels.all_off': 'כבה הכל',
    'channels.emergency_stop': 'עצירת חירום',
    'channels.update_success': 'ערוץ {0} עודכן בהצלחה',
    'channels.update_failed': 'עדכון ערוץ נכשל',
    'channels.control_success_on': 'ערוץ {0} הודלק',
    'channels.control_success_off': 'ערוץ {0} כובה',
    'channels.control_failed': 'שליטה בערוץ נכשלה',
    'channels.all_control_success_on': 'כל הערוצים הודלקו',
    'channels.all_control_success_off': 'כל הערוצים כובו',
    'channels.all_control_success_stop': 'עצירת חירום בוצעה',
    'channels.all_control_failed': 'שליטה בערוצים נכשלה',
    'channels.load_failed': 'טעינת ערוצים נכשלה',
    'channels.btn_edit': 'ערוך',
    'channels.btn_calibrate': 'כייל',
    'channels.btn_manual': 'ידני',
    'channels.manual_title': 'שליטה ידנית',
    'channels.manual_desc': 'שלוט בערוץ זה ידנית:',
    'channels.calibrate_confirm': 'האם אתה בטוח שברצונך לכייל ערוץ {0}?',
    'channels.calibrate_success': 'כיול ערוץ {0} החל',
    'channels.calibrate_failed': 'כיול ערוץ נכשל',
    'channels.syrup_name': 'שם סירופ',
    'channels.used_in_drinks': 'משמש במשקאות',
    'channels.calibration_duration': 'משך כיול',
    'channels.calib_start_msg': 'לחץ התחל כדי להתחיל בכיול, או השתמש בהזנה ידנית להזנת זמן כיול.',
    'channels.calib_running_msg': 'כיול בתהליך... אנא המתן.',
    'channels.calib_complete_msg': 'הכיול הושלם!',
    'channels.calib_result': 'משך: {0}s',
    'channels.calib_save': 'שמור',
    'channels.calib_retry': 'נסה שוב',
    'channels.calib_start': 'התחל',
    'channels.calib_cancel_btn': 'בטל',
    'channels.calib_close': 'סגור',
    'channels.calib_manual': 'הזנה ידנית',
    'channels.calib_manual_placeholder': 'זמן (ms)',
    'channels.calib_confirm': 'אשר',
    'channels.calib_canceled': 'הכיול בוטל',

    'drinks.title': 'משקאות',
    'drinks.add': 'הוסף משקה',
    'drinks.edit': 'ערוך',
    'drinks.base_drink': 'משקה בסיס',
    'drinks.delete_confirm': 'האם אתה בטוח שברצונך למחוק משקה זה?',
    'drinks.empty': 'לא נמצאו משקאות. צור את המשקה הראשון שלך!',
    'drinks.load_error': 'נכשל בטעינת משקאות',
    'drinks.create_success': 'משקה נוצר בהצלחה',
    'drinks.create_error': 'נכשל ביצירת משקה',
    'drinks.update_success': 'משקה עודכן בהצלחה',
    'drinks.update_error': 'נכשל בעדכון משקה',
    'drinks.delete_success': 'משקה נמחק בהצלחה',
    'drinks.delete_error': 'נכשל במחיקת משקה',
    'drinks.save_error': 'נכשל בשמירת משקה',
    'drinks.required_fields': 'נא למלא את כל השדות הנדרשים',
    'drinks.title_en': 'כותרת (אנגלית)',
    'drinks.title_he': 'כותרת (עברית)',
    'drinks.description_en': 'תיאור (אנגלית)',
    'drinks.description_he': 'תיאור (עברית)',
    'drinks.base_channel': 'ערוץ בסיס',
    'drinks.flavour_channel': 'ערוץ טעם',
    'drinks.no_flavour': 'ללא',
    'drinks.brix_ratio': 'יחס בריקס',
    'drinks.brix_ratio_a': 'יחס בריקס A',
    'drinks.brix_ratio_b': 'יחס בריקס B',
    'drinks.solenoid_only': 'ערוצי סולנואיד בלבד',
    'drinks.relay_only': 'ערוצי ממסר בלבד',
    'drinks.optional': 'אופציונלי',

    'pouring.title': 'מזיגה',
    'pouring.select_drink': 'בחר משקה',
    'pouring.select_drink_first': 'אנא בחר משקה תחילה',
    'pouring.pouring_mode': 'מצב מזיגה',
    'pouring.manual': 'ידני',
    'pouring.cup': 'כוס',
    'pouring.bottle': 'מיכל',
    'pouring.sweetness': 'רמת מתיקות',
    'pouring.light': 'קל',
    'pouring.regular': 'רגיל',
    'pouring.sweet': 'מתוק',
    'pouring.extra_sweet': 'מתוק במיוחד',
    'pouring.status': 'סטטוס מזיגה',
    'pouring.volume': 'נפח',
    'pouring.progress': 'התקדמות',
    'pouring.start': 'התחל מזיגה',
    'pouring.stop': 'עצור מזיגה',
    'pouring.emergency_stop': 'עצירת חירום',
    'pouring.started': 'המזיגה התחילה בהצלחה',
    'pouring.stopped': 'המזיגה נעצרה',
    'pouring.emergency_stopped': 'עצירת חירום בוצעה',
    'pouring.start_error': 'נכשל בהתחלת מזיגה',
    'pouring.stop_error': 'נכשל בעצירת מזיגה',
    'pouring.emergency_stop_error': 'נכשל בביצוע עצירת חירום',
    'pouring.completion_window': 'חלון סיום',
    'pouring.completed_waiting': 'המזיגה הושלמה. הסשן נשאר פתוח לטופ-אוף.',
    'pouring.completion_seconds_left': 'סגירה בעוד {0} שנ׳',
    'pouring.manual_top_off': 'טופ-אוף ידני',
    'pouring.manual_top_off_hint': 'אפשר לבצע טופ-אוף ידני לפני סגירת הסשן.',
    'pouring.hold_to_top_off': 'לחיצה רציפה לטופ-אוף',
    'pouring.tap_to_toggle_top_off': 'לחץ כדי להתחיל/לעצור טופ-אוף',
    'pouring.top_off_active': 'טופ-אוף פעיל',
    'pouring.top_off_stopped': 'טופ-אוף נעצר',

    'syrups.title': 'סירופים',
    'syrups.add': 'הוסף סירופ',
    'syrups.edit': 'ערוך סירופ',
    'syrups.delete_confirm': 'האם אתה בטוח שברצונך למחוק סירופ זה?',
    'syrups.empty': 'לא נמצאו סירופים. צור את הסירופ הראשון שלך!',
    'syrups.load_error': 'נכשל בטעינת סירופים',
    'syrups.create_success': 'סירופ נוצר בהצלחה',
    'syrups.create_error': 'נכשל ביצירת סירופ',
    'syrups.update_success': 'סירופ עודכן בהצלחה',
    'syrups.update_error': 'נכשל בעדכון סירופ',
    'syrups.delete_success': 'סירופ נמחק בהצלחה',
    'syrups.delete_error': 'נכשל במחיקת סירופ',
    'syrups.save_error': 'נכשל בשמירת סירופ',
    'syrups.required_fields': 'נא למלא את כל השדות הנדרשים',
    'syrups.name_en': 'שם (אנגלית)',
    'syrups.name_he': 'שם (עברית)',
    'syrups.description_en': 'תיאור (אנגלית)',
    'syrups.description_he': 'תיאור (עברית)',
    'syrups.package_size': 'גודל חבילה (ליטר)',
    'syrup_usage.title': 'שימוש בסירופים',
    'syrup_usage.load_error': 'נכשלה טעינת שימוש בסירופים',
    'syrup_usage.empty': 'לא נמצאו סירופים מקושרים',
    'syrup_usage.channel': 'ערוץ',
    'syrup_usage.used_ml': 'נצרך (מ״ל)',
    'syrup_usage.remaining_ml': 'נותר (מ״ל)',
    'syrup_usage.package_l': 'אריזה (ליטר)',
    'syrup_usage.remaining': 'נותר',
    'syrup_usage.replace': 'החלף סירופ',
    'syrup_usage.replace_success': 'שימוש הסירופ אופס',
    'syrup_usage.replace_error': 'נכשלה החלפת הסירופ',
    'pump_usage.title': 'שימוש משאבות',
    'pump_usage.load_error': 'נכשלה טעינת שימוש משאבות',
    'pump_usage.empty': 'לא נמצאו נתוני שימוש משאבות',
    'pump_usage.mode': 'מצב',
    'pump_usage.active': 'פעיל',
    'pump_usage.is_on': 'דולק',
    'pump_usage.runtime': 'זמן עבודה',
    'pump_usage.replace': 'החלף משאבה',
    'pump_usage.replace_success': 'זמן המשאבה אופס',
    'pump_usage.replace_error': 'נכשלה החלפת המשאבה',

    'ltsp101_catalog.title': 'קטלוג LTSP101',
    'ltsp101_catalog.syrups_tab': 'סירופים',
    'ltsp101_catalog.drinks_tab': 'משקאות',
    'ltsp101_catalog.images_tab': 'תמונות',
    'ltsp101_catalog.search': 'חפש בקטלוג...',
    'ltsp101_catalog.add_syrup': 'הוסף סירופ',
    'ltsp101_catalog.edit_syrup': 'ערוך סירופ',
    'ltsp101_catalog.add_drink': 'הוסף משקה',
    'ltsp101_catalog.edit_drink': 'ערוך משקה',
    'ltsp101_catalog.add_image': 'הוסף תמונה',
    'ltsp101_catalog.edit_image': 'ערוך תמונה',
    'ltsp101_catalog.syrups_empty': 'אין סירופים בקטלוג עדיין.',
    'ltsp101_catalog.drinks_empty': 'אין משקאות בקטלוג עדיין.',
    'ltsp101_catalog.images_empty': 'אין תמונות בקטלוג עדיין.',
    'ltsp101_catalog.load_error': 'נכשל בטעינת הקטלוג',
    'ltsp101_catalog.save_error': 'נכשל בשמירת פריט',
    'ltsp101_catalog.delete_error': 'נכשל במחיקת פריט',
    'ltsp101_catalog.required_fields': 'נא למלא את כל השדות הנדרשים',
    'ltsp101_catalog.syrup_create_success': 'סירופ נוסף לקטלוג',
    'ltsp101_catalog.syrup_update_success': 'סירופ עודכן',
    'ltsp101_catalog.syrup_delete_success': 'סירופ נמחק',
    'ltsp101_catalog.drink_create_success': 'משקה נוסף לקטלוג',
    'ltsp101_catalog.drink_update_success': 'משקה עודכן',
    'ltsp101_catalog.drink_delete_success': 'משקה נמחק',
    'ltsp101_catalog.image_create_success': 'תמונה נוספה לקטלוג',
    'ltsp101_catalog.image_update_success': 'תמונה עודכנה',
    'ltsp101_catalog.image_delete_success': 'תמונה נמחקה',
    'ltsp101_catalog.syrup_delete_confirm': 'האם אתה בטוח שברצונך למחוק סירופ זה?',
    'ltsp101_catalog.drink_delete_confirm': 'האם אתה בטוח שברצונך למחוק משקה זה?',
    'ltsp101_catalog.image_delete_confirm': 'האם אתה בטוח שברצונך למחוק תמונה זו?',
    'ltsp101_catalog.name_en': 'שם (אנגלית)',
    'ltsp101_catalog.name_he': 'שם (עברית)',
    'ltsp101_catalog.description_en': 'תיאור (אנגלית)',
    'ltsp101_catalog.description_he': 'תיאור (עברית)',
    'ltsp101_catalog.title_en': 'כותרת (אנגלית)',
    'ltsp101_catalog.title_he': 'כותרת (עברית)',
    'ltsp101_catalog.package_size': 'גודל חבילה',
    'ltsp101_catalog.image': 'תמונת קטלוג',
    'ltsp101_catalog.image_drop': 'גרור תמונה לכאן או לחץ להעלאה',
    'ltsp101_catalog.no_image': 'אין תמונה',
    'ltsp101_catalog.image_title': 'כותרת תמונה',
    'ltsp101_catalog.image_notes': 'הערות לתמונה',
    'ltsp101_catalog.image_title_en': 'כותרת תמונה (אנגלית)',
    'ltsp101_catalog.image_title_he': 'כותרת תמונה (עברית)',
    'ltsp101_catalog.image_notes_en': 'הערות לתמונה (אנגלית)',
    'ltsp101_catalog.image_notes_he': 'הערות לתמונה (עברית)',
    'ltsp101_catalog.image_title_hint': 'הכותרות מוגדרות לכל קובץ למטה (ברירת מחדל שם הקובץ).',
    'ltsp101_catalog.image_notes_hint': 'הערות מוגדרות לכל קובץ למטה.',
    'ltsp101_catalog.image_drop_multiple': 'גרור תמונות לכאן או לחץ להעלאה (ניתן מרובה)',
    'ltsp101_catalog.base_channel': 'ערוץ בסיס',
    'ltsp101_catalog.flavour_channel': 'ערוץ טעם',
    'ltsp101_catalog.no_flavour': 'ללא',
    'ltsp101_catalog.no_flavour_hint': 'השתמש ב-255 ללא ערוץ טעם',
    'ltsp101_catalog.brix_ratio': 'יחס בריקס',
    'ltsp101_catalog.brix_ratio_a': 'יחס בריקס A',
    'ltsp101_catalog.brix_ratio_b': 'יחס בריקס B',
    'ltsp101_catalog.api_docs_show': 'הצג תיעוד API',
    'ltsp101_catalog.api_docs_hide': 'הסתר תיעוד API',
    'ltsp101_catalog.api_docs_title': 'API קטלוג למערכות משובצות',
    'ltsp101_catalog.api_docs_intro': 'השתמש ב-API לקריאה בלבד עבור מכשירים משובצים לקבלת נתוני קטלוג.',
    'ltsp101_catalog.api_docs_auth_title': 'אימות',
    'ltsp101_catalog.api_docs_auth_body': 'ספק את מפתח ה-API בכותרת X-Api-Key או בפרמטר apiKey.',
    'ltsp101_catalog.api_docs_endpoints_title': 'נקודות קצה',
    'ltsp101_catalog.api_docs_endpoint_all': 'GET (כל נתוני הקטלוג):',
    'ltsp101_catalog.api_docs_endpoint_syrups': 'GET (סירופים):',
    'ltsp101_catalog.api_docs_endpoint_drinks': 'GET (משקאות):',
    'ltsp101_catalog.api_docs_endpoint_images': 'GET (תמונות):',
    'ltsp101_catalog.api_docs_endpoint_names': 'GET (שמות):',
    'ltsp101_catalog.api_docs_endpoint_image_data': 'GET (נתוני תמונה):',
    'ltsp101_catalog.api_docs_example_title': 'בקשת דוגמה',
    'ltsp101_catalog.api_docs_response_title': 'תגובה לדוגמה',
    'ltsp101_catalog.loading': 'טוען קטלוג...',
    'ltsp101_catalog.catalog': 'קטלוג',
    'ltsp101_catalog.include_downloaded': 'כלול שהורדו',
    'ltsp101_catalog.refresh': 'רענן',
    'ltsp101_catalog.total': 'סה״כ',
    'ltsp101_catalog.used': 'בשימוש',
    'ltsp101_catalog.free': 'פנוי',
    'ltsp101_catalog.remote_images': 'תמונות מרוחקות',
    'ltsp101_catalog.local_images': 'תמונות מקומיות',
    'ltsp101_catalog.download': 'הורד',
    'ltsp101_catalog.delete': 'מחק',
    'ltsp101_catalog.no_remote_images': 'אין תמונות מרוחקות',
    'ltsp101_catalog.no_local_images': 'אין תמונות מקומיות',
    'ltsp101_catalog.image_download_success': 'התמונה הורדה',
    'ltsp101_catalog.image_download_error': 'ההורדה נכשלה',
    'ltsp101_catalog.image_delete_error': 'המחיקה נכשלה',

    'system.title': 'מערכת',
    'system.info_section': 'מידע מערכת',
    'system.status_section': 'סטטוס מערכת',
    'system.settings_section': 'הגדרות',
    'system.app_version': 'גרסת אפליקציה',
    'system.idf_version': 'גרסת IDF',
    'system.part_name': 'שם חלק',
    'system.compile_date': 'תאריך קומפילציה',
    'system.compile_time': 'שעת קומפילציה',
    'system.cores': 'ליבות CPU',
    'system.revision': 'רוויזיית שבב',
    'system.flash_size': 'גודל זיכרון',
    'system.wifi_mac': 'כתובת MAC WiFi',
    'system.bt_mac': 'כתובת MAC Bluetooth',
    'system.uptime': 'זמן פעילות',
    'system.free_heap': 'זיכרון פנוי',
    'system.rtc_time': 'שעת RTC',
    'system.rtc_date': 'תאריך RTC',
    'system.timezone': 'אזור זמן',
    'system.brightness': 'בהירות',
    'system.brightness_adjust': 'התאם בהירות',
    'system.language': 'שפה',
    'system.language_select': 'בחר שפה',
    'system.time_date': 'שעה ותאריך',
    'system.set_time': 'הגדר שעה',
    'system.sync_time': 'סנכרן דרך NTP',
    'system.set_timezone': 'הגדר אזור זמן',
    'system.restart': 'אתחל מערכת',
    'system.restart_confirm': 'האם אתה בטוח שברצונך לאתחל את המערכת?',
    'system.restart_success': 'המערכת מאתחלת...',
    'system.restart_error': 'נכשל באתחול המערכת',
    'system.lock_now': 'נעל עכשיו',
    'system.lock_now_success': 'בקשת נעילה נשלחה',
    'system.lock_now_error': 'נעילת המערכת נכשלה',
    'system.admin_auth_title': 'אימות שער מנהל',
    'system.admin_auth_send': 'שלח מפתח מנהל',
    'system.admin_auth_key_label': 'מפתח מנהל',
    'system.admin_auth_key_required': 'יש להזין מפתח מנהל',
    'system.admin_auth_key_invalid': 'מפתח המנהל חייב להיות באורך 32 תווים בדיוק',
    'system.admin_auth_success': 'מפתח המנהל התקבל',
    'system.admin_auth_error': 'שליחת מפתח המנהל נכשלה',
    'system.admin_relock_send': 'נעל מנהל מחדש',
    'system.admin_relock_success': 'סשן המנהל ננעל מחדש',
    'system.admin_relock_error': 'בקשת נעילה מחדש נכשלה',
    'system.user_security': 'אבטחת משתמש',
    'system.lock_on_startup': 'נעילה בהפעלה',
    'system.user_pin_placeholder': 'קוד משתמש חדש (6 ספרות, אופציונלי)',
    'system.user_pin_invalid': 'הקוד חייב להיות בדיוק 6 ספרות',
    'system.user_security_save': 'שמור אבטחה',
    'system.user_security_saved': 'אבטחת המשתמש נשמרה',
    'system.user_security_save_error': 'שמירת אבטחת המשתמש נכשלה',
    'system.export_settings': 'ייצוא הגדרות',
    'system.export_name_prompt': 'בחר שם ייחודי לייצוא ההגדרות',
    'system.export_name_label': 'שם פרופיל',
    'system.export_name_required': 'נא להזין שם פרופיל',
    'system.export_saved_success': 'ההגדרות יוצאו ונשמרו בשם "{0}"',
    'system.import_settings': 'ייבוא הגדרות',
    'system.import_saved_settings': 'ייבוא שמור',
    'system.saved_profiles_empty': 'לא נמצאו פרופילי הגדרות שמורים',
    'system.export_success': 'הגדרות יוצאו בהצלחה',
    'system.export_error': 'נכשל בייצוא הגדרות',
    'system.import_success': 'הגדרות יובאו בהצלחה',
    'system.import_error': 'נכשל בייבוא הגדרות',
    'system.import_confirm': 'האם אתה בטוח שברצונך לייבא הגדרות? פעולה זו תדרוס את ההגדרות הנוכחיות.',
    'system.brightness_updated': 'בהירות עודכנה',
    'system.brightness_error': 'נכשל בעדכון בהירות',
    'system.time_updated': 'שעה עודכנה בהצלחה',
    'system.time_error': 'נכשל בעדכון שעה',
    'system.time_syncing': 'מסנכרן שעה...',
    'system.time_synced': 'שעה סונכרנה בהצלחה',
    'system.time_sync_error': 'נכשל בסנכרון שעה',
    'system.timezone_updated': 'אזור זמן עודכן',
    'system.timezone_error': 'נכשל בעדכון אזור זמן',
    'system.language_updated': 'שפה עודכנה',
    'system.language_error': 'נכשל בעדכון שפה',
    'system.select_timezone': 'בחר אזור זמן',
    'system.year': 'שנה',
    'system.month': 'חודש',
    'system.day': 'יום',
    'system.hour': 'שעה',
    'system.minute': 'דקה',
    'system.use_pc_time': 'השתמש בזמן המחשב',

    'general_settings.title': 'הגדרות כלליות',
    'general_settings.test_tube_volume': 'נפח מבחנה',
    'general_settings.test_tube_volume_desc': 'נפח מבחנה לכיול',
    'general_settings.rinse_duration': 'זמן מזיגה נוסף',
    'general_settings.rinse_duration_desc': 'מיושם לפני ואחרי מזיגת הטעם (חלון בסיס בלבד)',
    'general_settings.cup_volume': 'נפח כוס',
    'general_settings.cup_volume_desc': 'נפח כוס ברירת מחדל למשקאות',
    'general_settings.bottle_volume': 'נפח מיכל',
    'general_settings.bottle_volume_desc': 'נפח מיכל ברירת מחדל למשקאות',
    'general_settings.edit': 'ערוך',
    'general_settings.measure': 'מדוד',
    'general_settings.save': 'שמור',
    'general_settings.cancel': 'בטל',
    'general_settings.ml': 'מ"ל',
    'general_settings.ms': 'מילישניות',
    'general_settings.minutes': 'דקות',
    'general_settings.seconds': 'שניות',
    'general_settings.current_value': 'ערך נוכחי',
    'general_settings.new_value': 'ערך חדש',
    'general_settings.value_updated': 'הערך עודכן בהצלחה',
    'general_settings.update_error': 'נכשל בעדכון הערך',
    'general_settings.invalid_range': 'ערך מחוץ לטווח התקין',
    'general_settings.test_tube_range': 'נפח מבחנה חייב להיות בין 50-1000 מ"ל',
    'general_settings.rinse_range': 'ערכים מותרים: 0, 0.5ש׳, 1ש׳, 1.5ש׳, 2ש׳',
    'general_settings.cup_range': 'נפח כוס חייב להיות בין 50-2000 מ"ל',
    'general_settings.bottle_range': 'נפח המיכל חייב להיות בין 50-2000 מ"ל',
    'general_settings.calibration_stop_confirm': 'זמן אימות כיול',
    'general_settings.calibration_stop_confirm_desc': 'השהיה לפני עצירת תהליך כיול פעיל',
    'general_settings.calibration_stop_confirm_range': 'אישור עצירת כיול חייב להיות בין 0-5000 מילישניות',
    'general_settings.led_count': 'כמות לדים',
    'general_settings.led_count_desc': 'מספר הלדים שמוגדר במכשיר',
    'general_settings.led_count_range': 'כמות לדים חייבת להיות בין 1-300',
    'general_settings.manual_pour_mode': 'מצב מזיגה ידנית',
    'general_settings.manual_pour_mode_desc': 'בחר כיצד מזיגה ידנית תפעל',
    'general_settings.manual_mode_hold': 'לחיצה רציפה',
    'general_settings.manual_mode_toggle': 'הפעלה/כיבוי',
    'general_settings.home_logo': 'לוגו בית',
    'general_settings.home_logo_desc': 'מפתח הלוגו שמוצג במסך הבית',
    'general_settings.home_logo_range': 'מפתח לוגו חייב להיות באורך 0-128 תווים',
    'general_settings.pouring_completion_window': 'חלון סיום מזיגה',
    'general_settings.pouring_completion_window_desc': 'זמן המתנה עד לחזרה לעמוד המשקאות',
    'general_settings.pouring_completion_window_range': 'חלון הסיום חייב להיות בין 1000-10000 מילישניות',
    'general_settings.inactivity_timeout': 'זמן חזרה לדף בית',
    'general_settings.inactivity_timeout_desc': 'חזרה אוטומטית לבית לאחר חוסר פעילות במסכי המזיגה',
    'general_settings.inactivity_timeout_range': 'טיים-אאוט חוסר פעילות חייב להיות בין 5-3600 שניות',
    'general_settings.auto_rinse_duration': 'משך שטיפה אוטומטית',
    'general_settings.auto_rinse_duration_desc': 'משך הזמן שבו שטיפה אוטומטית פעילה',
    'general_settings.auto_rinse_duration_range': 'משך שטיפה אוטומטית חייב להיות בין 1 ל-3600 שניות',
    'general_settings.home_screensaver': 'שומר מסך בדף הבית',
    'general_settings.home_screensaver_desc': 'עמעום מסך הבית ל-30% לאחר חוסר פעילות ושחזור בהקשה הראשונה',
    'general_settings.home_screensaver_timeout': 'זמן שומר מסך בדף הבית',
    'general_settings.home_screensaver_timeout_desc': 'מספר דקות חוסר פעילות במסך הבית לפני עמעום',
    'general_settings.home_screensaver_timeout_range': 'זמן שומר מסך בדף הבית חייב להיות בין 1 ל-120 דקות',
    'general_settings.remote_live_log_stream': 'הזרמת לוגים חיה מרחוק',
    'general_settings.remote_live_log_stream_desc': 'הפעלת הזרמת לוגים חיה מהמכשיר באמצעות פקטות',
    'general_settings.remote_transport_mode': 'מצב תקשורת תמיכה מרחוק',
    'general_settings.remote_transport_mode_desc': 'בחירת תקשורת תמיכה מרחוק: TCP או פולינג HTTP',
    'general_settings.remote_transport_mode_tcp': 'TCP',
    'general_settings.remote_transport_mode_http': 'פולינג HTTP',
    'general_settings.http_polling_interval': 'מרווח HTTP Polling',
    'general_settings.http_polling_interval_desc': 'השהייה בין בקשות פולינג מוצלחות (חל רק במצב HTTP polling)',
    'general_settings.http_polling_interval_range': 'מרווח HTTP polling חייב להיות בין 0.1 ל-60 שניות',
    'general_settings.daily_auto_restart_enabled': 'אתחול אוטומטי כל 24 שעות',
    'general_settings.daily_auto_restart_enabled_desc': 'כאשר מופעל, המכשיר יבצע אתחול כל 24 שעות כל עוד ההגדרה הזו פעילה',
    'general_settings.operation_mode': 'מצב מסך מזיגה',
    'general_settings.operation_mode_desc': 'בחר מזיגה מהירה (Quick Pouring) או שירות עצמי (Self Service)',
    'general_settings.operation_mode_quick_pour': 'מזיגה מהירה',
    'general_settings.operation_mode_self_service': 'שירות עצמי',
    'general_settings.logging_enabled': 'לוגים מופעלים',
    'general_settings.logging_enabled_desc': 'שליטה גלובלית על לכידת לוגים במכשיר (יומן והזרמה חיה)',
    'general_settings.sanitation_enabled': 'אכיפת תברואה',
    'general_settings.sanitation_enabled_desc': 'הפעלה או השבתה של אכיפת תברואה (זמין גם בלשונית תברואה)',
    'general_settings.setup_completed': 'הגדרה ראשונית הושלמה',
    'general_settings.setup_completed_desc': 'קובע האם אשף ההגדרה הראשונית יידרש בהפעלה הבאה',
    'general_settings.live_logs_title': 'לוגים',
    'general_settings.live_logs_desc': 'שורות לוג מוזרמות בזמן אמת דרך WebSocket',
    'general_settings.live_logs_empty': 'עדיין אין לוגים חיים',
    'general_settings.live_logs_prepend_timestamp': 'הוסף חותמת זמן',
    'general_settings.live_logs_enable_persist': 'הפעל שמירה זמנית',
    'general_settings.live_logs_disable_persist': 'כבה שמירה זמנית',
    'general_settings.live_logs_clear': 'נקה לוגים',
    'general_settings.log_journal_title': 'יומן לוגים',
    'general_settings.log_journal_desc': 'יומן לוגים מדורג הנשמר בפלאש',
    'general_settings.log_journal_enable': 'הפעל לוגים',
    'general_settings.log_journal_disable': 'כבה לוגים',
    'general_settings.log_journal_clear': 'נקה יומן',
    'general_settings.log_journal_clear_confirm': 'למחוק את כל רשומות היומן?',
    'general_settings.log_journal_empty': 'אין רשומות ביומן',
    'general_settings.log_journal_refresh': 'רענן עמוד',
    'general_settings.enabled': 'מופעל',
    'general_settings.disabled': 'מושבת',
    'general_settings.measure_title': 'מדידת נפח',
    'general_settings.select_drink': 'בחר משקה למזיגה למדידה',
    'general_settings.no_base_drinks_for_measure': 'אין משקאות בסיס זמינים למדידה. יש ליצור לפחות משקה בסיס אחד.',
    'general_settings.measuring': 'מודד...',
    'general_settings.stop_measuring': 'עצור',
    'general_settings.pouring': 'מוזג',
    'general_settings.measure_status_pouring': 'מזיגה פעילה',
    'general_settings.measure_status_idle': 'ממתין',
    'general_settings.measured_volume': 'נפח שנמדד',
    'general_settings.save_volume': 'שמור נפח',
    'general_settings.retry_measurement': 'נסה שוב',
    'general_settings.measurement_saved': 'המדידה נשמרה בהצלחה',
    'general_settings.measurement_error': 'המדידה נכשלה',
    'auto_rinse.title': 'שטיפה אוטומטית',
    'auto_rinse.enabled': 'הפעל שטיפה אוטומטית',
    'auto_rinse.hours': 'שעות מתוזמנות',
    'auto_rinse.idle_threshold_sec': 'סף חוסר פעילות (דקות)',
    'auto_rinse.schedule_wait_sec': 'המתנה מקסימלית אחרי שעה מתוזמנת (שניות, 0 ללא טיים-אאוט)',
    'auto_rinse.duration_sec': 'משך שטיפה אוטומטית (שניות)',
    'auto_rinse.runtime': 'סטטוס זמן אמת',
    'auto_rinse.running': 'פעיל',
    'auto_rinse.yes': 'כן',
    'auto_rinse.no': 'לא',
    'auto_rinse.remaining': 'זמן נותר',
    'auto_rinse.last_rinse': 'זמן מאז שטיפה אחרונה',
    'auto_rinse.start_now': 'התחל שטיפה עכשיו',
    'auto_rinse.extend_30': 'הארך +30 שנ׳',
    'auto_rinse.load_error': 'טעינת נתוני שטיפה אוטומטית נכשלה',
    'auto_rinse.save_success': 'הגדרות שטיפה אוטומטית נשמרו',
    'auto_rinse.save_error': 'שמירת הגדרות שטיפה אוטומטית נכשלה',
    'auto_rinse.start_success': 'שטיפה אוטומטית התחילה',
    'auto_rinse.start_error': 'התחלת שטיפה אוטומטית נכשלה',
    'auto_rinse.extend_success': 'שטיפה אוטומטית הוארכה',
    'auto_rinse.extend_error': 'הארכת שטיפה אוטומטית נכשלה',
    'auto_rinse.cancel': 'בטל שטיפה',
    'auto_rinse.cancel_success': 'שטיפה אוטומטית בוטלה',
    'auto_rinse.cancel_error': 'ביטול שטיפה אוטומטית נכשל',
    'auto_rinse.idle_range': 'סף חוסר פעילות חייב להיות בין 1 ל-60 דקות',
    'auto_rinse.wait_range': 'זמן המתנה מקסימלי חייב להיות בין 0 ל-86400 שניות',
    'auto_rinse.duration_range': 'משך שטיפה אוטומטית חייב להיות בין 1 ל-3600 שניות',
    'public_texts.title': 'טקסטים ציבוריים',
    'public_texts.description': 'התאמת טקסטים למסכים הציבוריים. ערך ריק משתמש בברירת המחדל של הקושחה.',
    'public_texts.edit': 'ערוך',
    'public_texts.reset': 'ברירת מחדל',
    'public_texts.default_mode': '(ברירת מחדל של הקושחה)',
    'public_texts.load_error': 'טעינת טקסטים ציבוריים נכשלה',
    'public_texts.save_success': 'הטקסט עודכן',
    'public_texts.save_error': 'עדכון הטקסט נכשל',
    'public_texts.reset_success': 'הטקסט אופס לברירת המחדל',
    'public_texts.key_1': 'בית - שורת פתיחה 1',
    'public_texts.key_2': 'בית - שורת פתיחה 2',
    'public_texts.key_3': 'בית - כפתור התחלה',
    'public_texts.key_4': 'בחירת משקה - כותרת',
    'public_texts.key_5': 'בחירת משקה - כותרת משנה',
    'public_texts.key_6': 'הגדרת משקה - עצירת חירום',
    'public_texts.key_7': 'הגדרת משקה - כותרת מתיקות',
    'public_texts.key_8': 'הגדרת משקה - תת כותרת מתיקות',
    'public_texts.key_9': 'הגדרת משקה - כותרת גודל',
    'public_texts.key_10': 'הגדרת משקה - תווית מצב ידני',
    'public_texts.key_11': 'הגדרת משקה - תת כותרת ידני (לחיצה רציפה)',
    'public_texts.key_12': 'הגדרת משקה - תת כותרת ידני (הפעלה/כיבוי)',
    'public_texts.key_13': 'הגדרת משקה - תווית מצב כוס',
    'public_texts.key_14': 'הגדרת משקה - תווית מצב מיכל',
    'public_texts.key_15': 'מודאל מזיגה - כותרת',
    'public_texts.key_16': 'מודאל מזיגה - כותרת משנה',

    'bluetooth.title': 'Bluetooth',
    'bluetooth.enable': 'הפעל Bluetooth',
    'bluetooth.enabled': 'מופעל',
    'bluetooth.disabled': 'מושבת',
    'bluetooth.status': 'סטטוס',
    'bluetooth.connected': 'מחובר',
    'bluetooth.not_connected': 'לא מחובר',
    'bluetooth.advertising': 'משדר',
    'bluetooth.not_advertising': 'לא משדר',
    'bluetooth.device_name': 'שם Bluetooth',
    'bluetooth.customer_key': 'מפתח לקוח',
    'bluetooth.mac_address': 'כתובת MAC',
    'bluetooth.start_advertising': 'התחל שידור',
    'bluetooth.stop_advertising': 'עצור שידור',
    'bluetooth.edit_customer_key': 'ערוך מפתח לקוח',
    'bluetooth.new_customer_key': 'מפתח לקוח חדש',
    'bluetooth.device_name_updated': 'מפתח הלקוח עודכן בהצלחה',
    'bluetooth.advertising_started': 'השידור החל',
    'bluetooth.advertising_stopped': 'השידור הופסק',
    'bluetooth.bluetooth_enabled': 'Bluetooth הופעל',
    'bluetooth.bluetooth_disabled': 'Bluetooth הושבת',
    'bluetooth.error': 'פעולת Bluetooth נכשלה',
    'bluetooth.name_length_error': 'מפתח הלקוח חייב להיות בין 1-20 תווים',

    'wifi.title': 'WiFi',
    'wifi.enable': 'הפעל WiFi',
    'wifi.enabled': 'מופעל',
    'wifi.disabled': 'מושבת',
    'wifi.status': 'סטטוס',
    'wifi.connected': 'מחובר',
    'wifi.not_connected': 'לא מחובר',
    'wifi.ssid': 'שם רשת (SSID)',
    'wifi.ip_address': 'כתובת IP',
    'wifi.wifi_enabled': 'WiFi הופעל',
    'wifi.wifi_disabled': 'WiFi הושבת',
    'wifi.error': 'פעולת WiFi נכשלה',
    'wifi.state': 'מצב',
    'wifi.state_idle': 'סרק',
    'wifi.state_connecting': 'מתחבר',
    'wifi.state_connected': 'מחובר',
    'wifi.state_failed': 'נכשל',
    'wifi.connecting': 'מתחבר...',
    'wifi.connect': 'התחבר',
    'wifi.connect_to_network': 'התחברות לרשת',
    'wifi.password': 'סיסמה',
    'wifi.password_optional': 'סיסמה (ריק לרשת פתוחה)',
    'wifi.ssid_required': 'שם רשת (SSID) נדרש',
    'wifi.connect_accepted': 'בקשת החיבור התקבלה — ממתין למכשיר...',
    'wifi.connect_failed': 'ההתחברות לרשת WiFi נכשלה',
    'wifi.connected_to': 'מחובר ל',
    'wifi.wrong_password': 'סיסמה שגויה (אימות נכשל)',
    'wifi.network_not_found': 'הרשת לא נמצאה',
    'wifi.timeout': 'ההתחברות פגה — בדוק את מצב המכשיר',
    'wifi.forget': 'שכח רשת',
    'wifi.forget_confirm': 'לשכוח רשת זו? המכשיר יתנתק.',
    'wifi.forgot': 'הרשת נשכחה',
    'wifi.saved_ssid': 'רשת שמורה (SSID)',
    'wifi.rssi': 'עוצמת אות (RSSI)',
    'wifi.last_error': 'שגיאה אחרונה',
    'wifi.legacy_mode': 'מכשיר זה רץ על קושחה ישנה — משתמשים בתצורת ה-WiFi הקלאסית (סריקה, שם רשת וסיסמה).',
    'wifi.no_networks': 'לא נמצאו רשתות',
    'wifi.permission_denied': 'אין לך הרשאה לנהל את ה-WiFi של מכשיר זה. פנה למנהל המערכת כדי להעניק לך גישה.',

    'system_info.update_interval': 'מרווח עדכון נתונים',
    'system_info.epoch': 'תאריך ושעה',
    'system_info.uptime': 'זמן פעילות',
    'system_info.free_heap': 'זיכרון פנוי',
    'system_info.ntc1': 'תרמוסטט 1 (יחידת קירור)',
    'system_info.ntc2': 'תרמוסטט 2 (יחידת חימום)',
    'system_info.piezo1': 'חיישן לחץ H2O',
    'system_info.piezo2': 'חיישן לחץ CO2',
    'system_info.ice_sense': 'התנגדות קרח',
    'system_info.liquid_level': 'גובה מים',
    'system_info.liquid_high': 'גבוה',
    'system_info.liquid_low': 'נמוך',
    'system_info.fan_speed': 'מהירות מאוורר',
    'system_info.boiler_state': 'מצב בויילר',
    'system_info.fan_state': 'מצב מאוורר',
    'system_info.cooling_unit': 'יחידת קירור',
    'system_info.soda_unit': 'יחידת סודה',
    'system_info.cooling_unit_active_time': 'משך זמן פעילות יחידת קירור',
    'system_info.cooling_unit_inactive_time': 'משך זמן השהיית יחידת קירור',
    'system_info.pump_active_time': 'משך זמן פעילות משאבה',
    'system_info.pump_inactive_time': 'משך זמן השהיית משאבה',
    'system_info.boiler_active_time': 'משך זמן פעילות בויילר',
    'system_info.boiler_inactive_time': 'משך זמן השהיית בויילר',
    'system_info.rel_sols': 'סולנוידים',
    'system_info.rel_sol1_state': 'סולנויד 1',
    'system_info.rel_sol2_state': 'סולנויד 2',
    'system_info.rel_sol3_state': 'סולנויד 3',
    'system_info.rel_sol4_state': 'סולנויד 4',
    'system_info.rel_sol5_state': 'סולנויד 5',
    'system_info.rel_sol6_state': 'סולנויד 6',
    'system_info.rel_sol7_state': 'סולנויד 7',
    'system_info.rel_sol8_state': 'סולנויד 8',
    'system_info.vdet': 'VDET',
    'system_info.iprop': 'IPROP',
    'system_info.ambient_unit': 'יחידת סביבה',
    'system_info.circulation_pump': 'משאבת סחרור',
    'system_info.filter_filler': 'ממלא פילטרים',
    'system_info.rtc_battery': 'סוללת RTC',
    'system_info.rtc_battery_ok': 'תקין',
    'system_info.rtc_battery_invalid': 'לא תקין',
    'system_info.icebank_state': 'מצב IceBank',
    'system_info.icebank_state_idle': 'ממתין',
    'system_info.icebank_state_making_ice': 'מייצר קרח',
    'system_info.icebank_state_fault': 'תקלה',
    'system_info.icebank_state_retry_cooldown': 'המתנת ניסיון חוזר',
    'system_info.icebank_state_unknown': 'לא ידוע',
    'system_info.shabbat_info': 'שבת',
    'system_info.shabbat_setting_enabled': 'הגדרה פעילה',
    'system_info.shabbat_active': 'פעיל',

    'static_traits.version': 'גרסא',
    'static_traits.idf_ver': 'גרסאת IDF',
    'static_traits.cores': 'ליבות מעבד',
    'static_traits.model': 'דגם מעבד',
    'static_traits.revision': 'רביזיית מעבד',

    'build_flags.partname': 'שם פריט',
    'build_flags.soda_unit': 'יחידת סודה',
    'build_flags.cooling_unit': 'יחידת קירור',
    'build_flags.ambient_unit': 'יחידת סביבה',
    'build_flags.circulation_pump_unit': 'משאבת סחרור',
    'build_flags.heating_unit': 'יחידת חימום',
    'build_flags.bluetooth': 'בלוטות',
    'build_flags.wifi': 'ווי-פי',
    'build_flags.rel_sols': 'סולנוידים',
    'build_flags.serial': 'סריאל',
    'build_flags.keypad': 'מקלדת',

    'logs.empty_logs': 'אין לוגים להצגה',
    'logs.machine_logs': 'יומן מכשיר',
    'logs.sys_logs': 'יומן מערכת',
    'logs.parse_failed': 'ניתוח נכשל',
    'logs.show_all': 'הצג הכל',

    'settings.refresh': 'רענון',
    'settings.no_updates': 'אין מה לשמור',
    'settings.restore': 'איפוס הגדרות',
    'settings.restored': 'אופס',
    'settings.aluminium_block': 'בלוק אלומיניום',
    'settings.ice_bank': 'בנק קרח',
    'settings.general_settings': 'הגדרות כלליות',
    'settings.pump_settings': 'הגדרות יחידת סודה',
    'settings.cooling_unit_settings': 'הגדרות יחידת קירור',
    'settings.fix_errors': 'תקן את השגיאות ונסה שוב',
    'settings.must_be_numeric': 'הערך חייב להיות מספרי',
    'settings.program_mode': 'סוג מכונה',
    'settings.ntc1_max_value': "טמפ' מקסימלי",
    'settings.ntc1_min_value': "טמפ' מינימלי",
    'settings.water_value': 'סף מים',
    'settings.ice_value': 'סף קרח',
    'settings.icebank_max_work_time_minutes': 'זמן עבודה מקסימלי ל-IceBank (דקות)',
    'settings.icebank_retry_wait_minutes': 'זמן המתנה לניסיון חוזר ב-IceBank (דקות)',
    'settings.fan_pwm_duty': 'כוח מאוורר (%)',
    'settings.compressor_cooldown': 'זמן השהיית יחידת קירור (שניות)',
    'settings.pump_pwm_duty': 'כוח משאבה (%)',
    'settings.min_h2o_piezo': 'לחץ מים מינימלי',
    'settings.min_co2_piezo': 'לחץ פד"ח מינימלי',
    'settings.pump_max_time': 'זמן עבודה מקסימלי למשאבה (שניות)',
    'settings.piezo1_calib': 'קליברציית חיישן לחץ מים (מילי-וולט)',
    'settings.piezo2_calib': 'קליברציית חיישן לחץ פד"ח (מילי-וולט)',
    'settings.boiler_settings': 'הגדרות בוילר',
    'settings.boiler_max_heat': 'סף רתיחה מקסימלי',
    'settings.boiler_min_heat': 'סף רתיחה מינימלי',
    'settings.boiler_enable': 'הפעלת בוילר',
    'settings.wifi_enable': 'הפעלת ווי-פי',
    'settings.auto_socket_connect': 'חיבור אוטומטי לשרת',
    'settings.socket_transport_mode': 'סוג חיבור לשרת',
    'settings.socket_transport_mode_tcp': 'TCP Socket',
    'settings.socket_transport_mode_http_polling': 'HTTP Polling',
    'settings.http_poll_rate_ms': 'מרווח HTTP Polling (ms)',
    'settings.logging_enabled': 'לוגים מופעלים',
    'settings.remote_live_log_stream_enabled': 'הזרמת לוגים חיה מרחוק',
    'settings.ignore_h2o_piezo': 'התעלם מלחץ H2O',
    'settings.ignore_co2_piezo': 'התעלם מלחץ CO2',
    'settings.one_liq_lev': 'מד גובה מים יחיד',
    'settings.one_liq_lev_delay': 'זמן המתנה לאחר מים מלאים (שניות)',
    'settings.fan_disabled': 'השבתת מאוורר',
    'settings.liquid_level_enabled': 'הפעלת יחידת סודה',
    'settings.pump_start_delay': 'זמן המתנה להפעלת משאבה (שניות)',
    'settings.pump_stop_delay': 'זמן המתנה לכיבוי משאבה (שניות)',
    'settings.ambient_unit_settings': 'הגדרות יחידת סביבה',
    'settings.ambient_monitor_enabled': 'הפעלת יחידת סביבה',
    'settings.ntc2_max_value': 'טמפרטורת מקסימום',
    'settings.ntc2_min_value': 'טמפרטורת מינימום',
    'settings.fan_max_work_time': 'זמן עבודה מקסימלי למאוורר (שניות)',
    'settings.fan_cool_time': 'זמן השהיית מאוורר (שניות)',
    'settings.circulation_pump_settings': 'הגדרות משאבת סחרור',
    'settings.circulation_delay_stop': 'זמן המתנה לכיבוי משאבת סחרור (שניות)',
    'settings.circulation_interval': 'מרווח זמן להפעלת משאבת סחרור (שניות)',
    'settings.circulation_work_time': 'זמן עבודה מקסימלי למשאבת סחרור (שניות)',
    'settings.circulation_enabled': 'הפעלת משאבת סחרור',
    'settings.cooling_unit_enabled': 'הפעלת יחידת קירור',
    'settings.one_liq_lev_indicator_is_low': 'בחר רגש מד גובה מים',
    'settings.lower_level': 'רגש נמוך',
    'settings.higher_level': 'רגש גבוה',
    'settings.shabbat_settings': 'הגדרות שבת',
    'settings.shabbat_mode_enabled': 'הפעלת מצב שבת',
    'settings.shabbat_high_delay_min_ms': 'השהייה גבוהה מינימום (שניות)',
    'settings.shabbat_high_delay_max_ms': 'השהייה גבוהה מקסימום (שניות)',
    'settings.shabbat_low_delay_min_ms': 'השהייה נמוכה מינימום (שניות)',
    'settings.shabbat_low_delay_max_ms': 'השהייה נמוכה מקסימום (שניות)',
    'settings.shabbat_low_cs_sleep_add_ms': 'תוספת השהייה CS נמוכה (שניות)',
    'settings.shabbat_cooling_interval_minutes': 'מרווח קירור שבת (דקות)',
    'settings.shabbat_cooling_check_minutes': 'בדיקת קירור שבת (דקות)',

    'wificonfig.sta_settings': 'הגדרות סטיישן',
    'wificonfig.sta_ssid': 'שם סטיישן',
    'wificonfig.sta_pass': 'סיסמת סטיישן',
    'wificonfig.sta_warning': '* בלחיצה על כפתור השמירה החיבור ינותק.',
    'wificonfig.scan': 'סריקת ווי-פי',
    'wificonfig.connect': 'התחבר',

    'datetime.sync_with_local': 'סנכרן עם שעת מחשב',

    'customerdata.name': 'שם לקוח',
    'customerdata.address': 'כתובת',
    'customerdata.city': 'עיר',
    'customerdata.telephone': 'טלפון',
    'customerdata.cellphone1': 'פלאפון 1',
    'customerdata.cellphone2': 'פלאפון 2',
    'customerdata.mail': 'דואר אלקטרוני',
    'customerdata.company': 'חברה',
    'customerdata.notes': 'הערות',
    'customerdata.key': 'מפתח',
    'customerdata.key_max_length': 'מפתח לא יכול לעבור 20 תווים',
    'customerdata.key_english_only': 'מפתח חייב להכיל רק תווים באנגלית',
    'customerdata.characters': 'תווים',

    'system_actions.restart': 'הפעלה מחדש',
    'system_actions.restart_message': 'ההפעלה מחדש תתבצע בעוד שניה',
    'system_actions.test_env_enable': 'התחל מצב בדיקה',
    'system_actions.test_env_disable': 'סיים מצב בדיקה',
    'system_actions.fan': 'מאוורר',
    'system_actions.cooling_unit': 'יחידת קירור',
    'system_actions.pump': 'משאבה',
    'system_actions.boiler': 'בויילר',
    'system_actions.rel_sol1': 'סולנויד 1',
    'system_actions.rel_sol2': 'סולנויד 2',
    'system_actions.rel_sol3': 'סולנויד 3',
    'system_actions.rel_sol4': 'סולנויד 4',
    'system_actions.rel_sol5': 'סולנויד 5',
    'system_actions.rel_sol6': 'סולנויד 6',
    'system_actions.rel_sol7': 'סולנויד 7',
    'system_actions.rel_sol8': 'סולנויד 8',
    'system_actions.compressor': 'מדחס',
    'system_actions.delete_logs': 'מחק לוגים',
    'system_actions.monitoring_enable': 'הפעלת ניטור',
    'system_actions.monitoring_disable': 'השבתת ניטור',

    'ota.start': 'התחלת עדכון',
    'ota.start_legacy': 'התחלת עדכון (Legacy)',
    'ota.start_http': 'התחלת עדכון (HTTP)',
    'ota.stop': 'ביטול עדכון',
    'license.title': 'רישוי',
    'license.load_error': 'טעינת נתוני רישוי נכשלה',
    'license.policy_updated': 'המדיניות עודכנה',
    'license.policy_update_failed': 'עדכון המדיניות נכשל',
    'license.license_key_required': 'נדרש מפתח רישיון',
    'license.activated': 'הרישיון הופעל',
    'license.activation_failed': 'ההפעלה נכשלה',
    'license.check_complete': 'בדיקת הרישיון הושלמה',
    'license.check_failed': 'בדיקת הרישיון נכשלה',
    'license.temp_unlock_granted': 'פתיחה זמנית אושרה',
    'license.temp_unlock_failed': 'הפתיחה הזמנית נכשלה',
    'license.required': 'נדרש',
    'license.status': 'סטטוס',
    'license.can_start_new_pour': 'ניתן להתחיל מזיגה חדשה',
    'license.ntp_synced_once': 'בוצע סנכרון NTP לפחות פעם אחת',
    'license.temp_unlock_used_cycle': 'פתיחה זמנית נוצלה במחזור',
    'license.plan': 'תוכנית',
    'license.cycle_id': 'מזהה מחזור',
    'license.activation': 'הפעלה',
    'license.expiry': 'תפוגה',
    'license.temp_unlock_until': 'פתיחה זמנית עד',
    'license.last_check': 'בדיקה אחרונה',
    'license.seconds_until_expiry': 'שניות עד תפוגה',
    'license.seconds_until_temp_unlock_end': 'שניות עד סיום פתיחה זמנית',
    'license.message': 'הודעה',
    'license.refresh': 'רענן',
    'license.activation_section': 'הפעלה',
    'license.license_key': 'מפתח רישיון',
    'license.activate': 'הפעל',
    'license.check_now': 'בדוק עכשיו',
    'license.temp_unlock_section': 'פתיחה זמנית',
    'license.requested_seconds': 'שעות מבוקשות',
    'license.request_temp_unlock': 'בקש פתיחה זמנית',
    'license.policy_section': 'מדיניות',
    'license.license_required': 'נדרש רישיון',
    'license.trial_days': 'ימי ניסיון',
    'license.default_temp_unlock_sec': 'פתיחה זמנית ברירת מחדל (שעות)',
    'license.yes': 'כן',
    'license.no': 'לא',
    'license.status_not_required': 'לא נדרש',
    'license.status_waiting_ntp': 'ממתין ל-NTP',
    'license.status_trial': 'ניסיון',
    'license.status_active': 'פעיל',
    'license.status_temp_unlock': 'פתיחה זמנית',
    'license.status_expired': 'פג תוקף',
    'license.status_revoked': 'נשלל',
    'license.status_none': 'ללא רישיון',
    'sanitation.title': 'תברואה',
    'sanitation.load_error': 'טעינת נתוני תברואה נכשלה',
    'sanitation.status': 'סטטוס',
    'sanitation.status_waiting_for_sync': 'ממתין לסנכרון',
    'sanitation.status_compliant': 'תקין',
    'sanitation.status_due_soon': 'מתקרב למועד',
    'sanitation.status_overdue': 'עבר מועד',
    'sanitation.status_disabled': 'מושבת',
    'sanitation.enabled': 'מופעל',
    'sanitation.can_start_new_pour': 'ניתן להתחיל מזיגה חדשה',
    'sanitation.ntp_synced_once': 'בוצע סנכרון NTP לפחות פעם אחת',
    'sanitation.interval_days': 'מרווח (ימים)',
    'sanitation.warning_days': 'חלון אזהרה (ימים)',
    'sanitation.seconds_until_due': 'שניות עד מועד יעד',
    'sanitation.last_completed': 'הושלם לאחרונה',
    'sanitation.next_due': 'יעד הבא',
    'sanitation.last_check': 'בדיקה אחרונה',
    'sanitation.message': 'הודעה',
    'sanitation.check_now': 'בדוק עכשיו',
    'sanitation.check_success': 'בדיקת תברואה הושלמה',
    'sanitation.check_error': 'בדיקת תברואה נכשלה',
    'sanitation.complete_now': 'השלם תברואה',
    'sanitation.complete_success': 'תברואה הושלמה',
    'sanitation.complete_error': 'השלמת תברואה נכשלה',
    'sanitation.policy': 'מדיניות',
    'sanitation.policy_saved': 'מדיניות תברואה נשמרה',
    'sanitation.policy_error': 'עדכון מדיניות תברואה נכשל',
    'sanitation.interval_hint': 'טווח תקין: 30-3650 ימים.',
    'sanitation.interval_range': 'המרווח חייב להיות בין 30 ל-3650 ימים',
    'ota.select_software': 'בחר גרסא',
    'ota.start_err_already_patching': 'המכשיר כבר נמצא במצב עדכון',
    'ota.start_err_not_in_sync': 'השרת לא מסונכרן עם המכשיר, אנא בצע אתחול מחדש',
    'ota.success_message': 'העדכון הסתיים בהצלחה, המכשיר כעת יאותחל מחדש',
    'ota.write_err_already_active': 'המכשיר כבר נמצא במצב עדכון',
    'ota.write_err_begin_failed': 'התחלת העדכון נכשלה',
    'ota.write_err_current_running_version_same_as_new': 'הגרסה הנוכחית הפועלת זהה לגרסה חדשה',
    'ota.write_err_new_version_same_as_invalid_version': 'גרסה חדשה זהה לגרסה לא חוקית',
    'ota.write_err_received_package_not_fit_len': 'החבילה שהתקבלה אינה מתאימה לאורך',
    'ota.write_err_write_failed': 'הכתיבה למכשיר נכשלה, מנסה שוב',
    'ota.bin_model_mismatch': "מודל המעבד ({0}) לא תואם למזהה הצ'יפ ({1})",
    'ota.c6_subtitle': 'קושחת מעבד ה-WiFi/Bluetooth ESP32-C6 (network_adapter). דחוף את הקובץ דרך הסוקט, או תן למכשיר להוריד אותו דרך HTTP.',
    'ota.c6_select_software': 'בחר גרסת מודול WiFi',
    'ota.c6_no_versions': 'עדיין לא פורסמה קושחת C6 לדגם מכשיר זה',
    'ota.c6_update_http': 'עדכן מודול WiFi (HTTP)',
    'ota.c6_update_push': 'עדכן מודול WiFi (Push)',
    'ota.c6_updating': 'מעדכן את מודול ה-WiFi...',
    'ota.c6_completed': 'מודול ה-WiFi עודכן בהצלחה. המכשיר יאותחל מחדש ויתחבר בקרוב.',

    'files_error.invalid_file_type': 'סוג קובץ לא תיקני',
    'files_error.too_large': 'הקובץ גדול מידי',
    'files_error.too_small': 'הקובץ קטן מידי',
    'files_error.maximum_file_count_reached': 'לא ניתן להוסיף קבצים נוספים',

    'esp_bin_input.dnd_message': 'גרור ושחרר את הקובץ BIN בכל מקום',
    'esp_bin_input.invalid_message': 'קובץ BIN לא תקין',
    'esp_bin_input.unsupported_model_message': 'BIN לא של מודל {0}',
    'esp_bin_input.compiled_at': 'קומפל בתאריך {0} בשעה {1}',
    'esp_bin_input.app_elf_sha256': 'Sha256 של קובץ Elf',

    'datacenter.search_query': 'שאילתת חיפוש מכשיר',
    'datacenter.received_logs': 'התקבלו יומנים',

    'machine.machine_data': 'נתוני מכשיר',
    'machine.logs': 'יומנים',

    'software_manager.no_software_versions': 'העלה את גסאת התוכנה הראשונה שלך ע"י לחיצה על כפתור הפלוס',
    'software_manager.version': 'גרסאת תוכנה',
    'software_manager.model': 'דגם מכשיר',
    'software_manager.component': 'רכיב קושחה',
    'software_manager.component_app': 'קושחת היישום',
    'software_manager.component_c6': 'מודול WiFi (C6)',
    'software_manager.change_log': 'יומן שינויים',
    'software_manager.uploaded_by': 'הועלה ע"י',
    'software_manager.created_at_format': "'הועלה בתאריך' dd.MM.yyyy 'בשעה' HH:mm",
    'mobile_apps.title': 'הפצת אפליקציות מובייל',
    'mobile_apps.desc': 'העלה קבצי APK לאנדרואיד וקבצי IPA ל-iOS Ad Hoc, וקבל קישורי התקנה במקום אחד.',
    'mobile_apps.android_title': 'Android APK',
    'mobile_apps.android_desc': 'העלה APK חתום ושתף קישור הורדה ישיר.',
    'mobile_apps.ios_title': 'iOS Ad Hoc (IPA)',
    'mobile_apps.ios_desc': 'העלה IPA וקבל קישור התקנה מסוג itms-services עם manifest שנוצר אוטומטית.',
    'mobile_apps.drop_apk': 'גרור APK לכאן או לחץ לבחירה',
    'mobile_apps.drop_ipa': 'גרור IPA לכאן או לחץ לבחירה',
    'mobile_apps.app_title_placeholder': 'שם אפליקציה (אופציונלי)',
    'mobile_apps.version_placeholder': 'גרסה (אופציונלי)',
    'mobile_apps.notes_placeholder': 'הערות גרסה (אופציונלי)',
    'mobile_apps.ios_title_placeholder': 'שם אפליקציה (אופציונלי)',
    'mobile_apps.bundle_placeholder': 'Bundle Identifier (למשל com.company.app)',
    'mobile_apps.upload_apk': 'העלה APK',
    'mobile_apps.upload_ipa': 'העלה IPA',
    'mobile_apps.releases': 'גרסאות שהועלו',
    'mobile_apps.empty': 'עדיין לא הועלו קבצים.',
    'mobile_apps.download': 'הורדה',
    'mobile_apps.copy_link': 'העתק קישור',
    'mobile_apps.install_ios': 'התקן iOS',
    'mobile_apps.copy_install_link': 'העתק קישור התקנה',
    'mobile_apps.edit_title': 'ערוך שם אפליקציה',
    'mobile_apps.title_updated': 'שם האפליקציה עודכן',
    'mobile_apps.title_update_failed': 'עדכון שם האפליקציה נכשל',
    'mobile_apps.title_required': 'שם אפליקציה הוא שדה חובה',
    'mobile_apps.delete_confirm': 'למחוק את ההעלאה הזו?',
    'mobile_apps.copied': 'הקישור הועתק',
    'mobile_apps.copy_failed': 'העתקת הקישור נכשלה',
    'mobile_apps.load_failed': 'טעינת רשימת ההעלאות נכשלה',
    'mobile_apps.upload_success': 'ההעלאה הושלמה',
    'mobile_apps.upload_failed': 'ההעלאה נכשלה',
    'mobile_apps.pick_apk_first': 'בחר קודם קובץ APK',
    'mobile_apps.pick_ipa_first': 'בחר קודם קובץ IPA',
    'mobile_apps.delete_failed': 'מחיקת ההעלאה נכשלה',

    'usb_flash_artifacts.title': 'קבצי צריבה ל-USB',
    'usb_flash_artifacts.desc': 'העלאת מניפסטים וקבצי BIN לצריבת USB מתוך האפליקציה הניידת.',
    'usb_flash_artifacts.upload_title': 'העלאת חבילת צריבה חדשה',
    'usb_flash_artifacts.manifest_json': 'קובץ Manifest JSON',
    'usb_flash_artifacts.parse_manifest': 'פענח מניפסט',
    'usb_flash_artifacts.parse_manifest_first': 'יש לפענח את המניפסט תחילה',
    'usb_flash_artifacts.pick_manifest_first': 'בחר קודם קובץ מניפסט JSON',
    'usb_flash_artifacts.manifest_parsed': 'המניפסט פוענח בהצלחה',
    'usb_flash_artifacts.manifest_parse_failed': 'פענוח המניפסט נכשל',
    'usb_flash_artifacts.id_placeholder': 'מזהה מניפסט (אופציונלי)',
    'usb_flash_artifacts.title_placeholder': 'כותרת (אופציונלי)',
    'usb_flash_artifacts.chip_placeholder': 'צ׳יפ (esp32p4 / esp32s3 / esp32c6)',
    'usb_flash_artifacts.model_placeholder': 'מודל',
    'usb_flash_artifacts.version_placeholder': 'גרסה (אופציונלי)',
    'usb_flash_artifacts.pick_model': 'יש לבחור מודל לפני העלאה',
    'usb_flash_artifacts.chip_auto': 'צ׳יפ (אוטומטי לפי מודל)',
    'usb_flash_artifacts.overwrite': 'דרוס מניפסט קיים עם אותו מזהה',
    'usb_flash_artifacts.segments': 'קבצי BIN לפי המניפסט',
    'usb_flash_artifacts.upload_button': 'העלה חבילת צריבה',
    'usb_flash_artifacts.upload_success': 'חבילת הצריבה הועלתה',
    'usb_flash_artifacts.upload_failed': 'העלאת חבילת הצריבה נכשלה',
    'usb_flash_artifacts.load_failed': 'טעינת מניפסטים לצריבת USB נכשלה',
    'usb_flash_artifacts.existing': 'מניפסטים קיימים',
    'usb_flash_artifacts.empty': 'לא נמצאו מניפסטים לצריבת USB',
    'usb_flash_artifacts.missing_segment': 'חסר קובץ BIN עבור הנתיב: {0}',
    'usb_flash_artifacts.filter_title_placeholder': 'סינון לפי מודל/שם',
    'usb_flash_artifacts.filter_model_all': 'כל המודלים',
    'usb_flash_artifacts.delete_confirm': 'למחוק מניפסט "{0}"?',
    'usb_flash_artifacts.delete_success': 'המניפסט נמחק',
    'usb_flash_artifacts.delete_failed': 'מחיקת המניפסט נכשלה',

    'client_model.standard': 'Standard (0x0001)',
    'client_model.lti525s': 'LTI525S (0x0002)',
    'client_model.syrup_tower': 'Syrup Tower (0x0003)',
    'client_model.filter_filler': 'Filter Filler (0x0004)',
    'client_model.ltsp101': 'LTSP101 (0x0005)',
    'client_model.ltcb220': 'LTCB220 (0x0006)',
    'client_model.ltsp70': 'LTSP70 (0x0007)',
    'client_model.ltsp175': 'LTSP175 (0x0008)',
    'client_model.ltcb226': 'LTCB226 (0x0009)',

    'window.confirm': 'אישור',
    'window.decline': 'ביטול',

    'flash_device.begin_flash': 'התחל צריבה',
    'flash_device.flashing': 'מבצע צריבה...',
    'flash_device.flash_complete': 'הצריבה הושלמה',
    'flash_device.flash_failed': 'הצריבה נכשלה',

    'memory.kb': 'קילו-בייט',
    'memory.mb': 'מגה-בייט',
    'memory.gb': 'גיגה-בייט',
} as ILocaleStrings
